import React from 'react';
import {
  Card,
  Stack,
  HelpLink,
  withTranslation,
  TFunction,
} from '@piwikpro/ui-components';
import { errorBoundary, withInject } from '@piwikpro/platform';
import TrackingECommerce from './TrackingECommerce';
import SharepointIntegration from './SharepointIntegration';
import RealTimeDashboards from './RealTimeDashboards';

export interface ReportDetailsProps {
  t: TFunction
  Title: typeof React.Component
}

class Reports extends React.Component<ReportDetailsProps, {}> {
  render() {
    const {
      t,
      Title,
    } = this.props;

    return (
      <Title part={t('apps.details.tabs.reports')}>
        <Stack vertical spacing="extraWide">
          <Stack.Item fill>
            <Card>
              <Card.Section>
                <Stack vertical horizontalAlignment="middle">
                  <Stack.Item fill>
                    <RealTimeDashboards />
                  </Stack.Item>
                  <Stack.Item>
                    <HelpLink href="https://help.piwik.pro/support/reports/real-time-dashboards/">
                      Use real-time dashboards for live traffic monitoring
                    </HelpLink>
                  </Stack.Item>
                </Stack>
              </Card.Section>
            </Card>
          </Stack.Item>
          <Stack.Item fill>
            <Card>
              <Card.Section>
                <Stack vertical horizontalAlignment="middle">
                  <Stack.Item fill>
                    <TrackingECommerce />
                  </Stack.Item>
                  <Stack.Item>
                    <HelpLink href="https://help.piwik.pro/support/getting-started/track-ecommerce/">
                      Track ecommerce
                    </HelpLink>
                  </Stack.Item>
                </Stack>
              </Card.Section>
            </Card>
          </Stack.Item>
          <Stack.Item fill>
            <Card>
              <Card.Section>
                <Stack vertical horizontalAlignment="middle">
                  <Stack.Item fill>
                    <SharepointIntegration />
                  </Stack.Item>
                  <Stack.Item>
                    <HelpLink href="https://help.piwik.pro/support/integrations/sharepoint-integration/">
                      SharePoint integration
                    </HelpLink>
                  </Stack.Item>
                </Stack>
              </Card.Section>
            </Card>
          </Stack.Item>
        </Stack>
      </Title>
    );
  }
}

export default withInject({
  Title: 'TitleCrate.components.Title',
})(
  withTranslation(['administration'])(errorBoundary(Reports)),
);
